import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import {createEpicMiddleware} from "redux-observable";
import createRootReducer from "./reducers";
import {rootEpic} from "./epics";
import {AppState, WorkforceRoute} from "./AppState";

export default function configureStore(history: History<WorkforceRoute>, initialState?: AppState) {
    const epicMiddleware = createEpicMiddleware();
    const middleware = [routerMiddleware(history), epicMiddleware];
    const enhancers = [];
    const windowIfDefined = typeof window === 'undefined' ? null : window as any;
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }
    const store =  createStore(
        createRootReducer(history),
        // TODO: Type 'unknown' is not assignable to type 'never'// initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
    epicMiddleware.run(rootEpic);
    return store;
}
